import { z } from 'zod'

export const ConfigurationExcludedPhoneNumbersZod = z.object({
  phoneNumbers: z
    .array(
      z.object({
        phoneNumber: z.string(),
        decision: z.string(),
      })
    )
    .default([]),
})
